import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `admin/Empresa/editEmpresa`, method: 'POST', body: values, token: token})
}